import CrudTemplate from "../crudTemplate";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CidadeService from "../../services/resource/cidadeService";
import EstadoService from "../../services/resource/estadoService";
import FornecedorService from "../../services/resource/forncedorService";
import TipoFornecedorService from "../../services/resource/tipoFornecedor";

export default function FornecedorCrud() {
    const service = new FornecedorService();
    const cidadeService = new CidadeService();
    const estadoService = new EstadoService();
    const tipoFornecedorService = new TipoFornecedorService();

    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);
    const [tiposFornecedores, setTiposFornecedores] = useState([]);

    useEffect(() => {
        cidadeService.listar().then(res => setCidades(res.data));
        estadoService.listar().then(res => setEstados(res.data));
        tipoFornecedorService.listar().then(res => setTiposFornecedores(res.data));
    }, [])

    // Ao sair do campo CNPJ, consulta a BrasilAPI e preenche automaticamente os campos que ela
    // retorna — nunca sobrescreve com valor vazio (só atualiza o que a consulta efetivamente trouxe),
    // pra não apagar algo que o usuário já tenha digitado manualmente. Mesmo padrão já usado em
    // NovaSolicitacaoCadastroClienteForm.jsx (busca de CNPJ para Cadastro de Cliente).
    function aoSairDoCnpj(cnpjValor, handleChange) {
        const cnpjLimpo = (cnpjValor || "").replace(/\D/g, "");
        if (cnpjLimpo.length !== 14) return;

        const preencher = (campo, valor) => {
            if (valor) handleChange(campo, valor);
        };

        fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`)
            .then(res => {
                if (!res.ok) throw new Error("CNPJ não encontrado.");
                return res.json();
            })
            .then(data => {
                const estado = estados.find(e => (e.uf || "").toUpperCase() === (data.uf || "").toUpperCase());
                const cidade = cidades.find(c =>
                    (c.nome || "").toLowerCase() === (data.municipio || "").toLowerCase()
                    && (!estado || c.estadoId === estado.id)
                );

                preencher("nome", data.razao_social);
                preencher("nomeFantasia", data.nome_fantasia || data.razao_social);
                preencher("email", data.email);
                preencher("telefone1", data.ddd_telefone_1);
                preencher("cep", data.cep ? String(data.cep) : null);
                preencher("endereco", data.logradouro);
                preencher("numero", data.numero);
                preencher("bairro", data.bairro);
                preencher("complemento", data.complemento);
                if (estado) handleChange("estadoId", estado.id);
                if (cidade) handleChange("cidadeId", cidade.id);

                toast.success("Dados do CNPJ preenchidos automaticamente. Confira antes de salvar.");
            })
            .catch(() => toast.info("CNPJ não encontrado na Receita Federal. Preencha os dados manualmente."));
    }

    const formFields = [
        {
            name: "nome",
            label: "Nome/Razão Social",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "nomeFantasia",
            label: "Nome Fantasia",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "tipoFornecedorId",
            label: "Tipo",
            type: 'dropdown',
            options: tiposFornecedores,
            optionLabel: "descricao",
            optionValue: "id",
            colSpan: 1
        },
        {
            name: "cpf",
            label: "CPF",
            type: "inputMask",
            mask: '999.999.999-99',
            colSpan: 1
        },
        {
            name: "cnpj",
            label: "CNPJ",
            type: "inputMask",
            mask: '99.999.999/9999-99',
            colSpan: 1,
            onBlur: aoSairDoCnpj
        },
        {
            name: "cep",
            label: "CEP",
            type: "inputMask",
            mask: '99999-999',
            colSpan: 1
        },
        {
            name: "endereco",
            label: "Logradouro",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "numero",
            label: "Número",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "bairro",
            label: "Bairro",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "complemento",
            label: "Complemento",
            type: "input",
            typeText: "text",
            colSpan: 1
        },

        {
            name: "cidadeId",
            label: "Cidade",
            type: "dropdown",
            options: cidades,
            optionLabel: "nome",
            optionValue: "id",
            colSpan: 1
        },
        {
            name: "estadoId",
            label: "Estado",
            type: "dropdown",
            options: estados,
            optionLabel: "nome",
            optionValue: "id",
            colSpan: 1
        },

        {
            name: "email",
            label: "E-mail",
            type: "input",
            typeText: "text",
            colSpan: 1
        },

        {
            name: "telefone1",
            label: "Contato (1)",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "telefone2",
            label: "Contato (2)",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "inscricaoEstadual",
            label: "Inscrição Estadual",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "inscricaoMunicipal",
            label: "Inscrição Municipal",
            type: "input",
            typeText: "text",
            colSpan: 1
        },
        {
            name: "ativo",
            label: "Cadastro ativo",
            type: "booleanFooter"
        },
        {
            name: "juridico",
            label: "Cadastro jurídico",
            type: "booleanFooter"
        }
    ];

    const tableColumns = [
        { key: "nome", label: "Razão Social", bold: true },
        { key: "nomeFantasia", label: "Nome Fantasia" },
        { key: "cnpj", label: "CNPJ" },
        { key: "tipoFornecedorDescricao", label: "Tipo" },
        { key: "cidadeNome", label: "Cidade" },
        { key: "estadoNome", label: "Estado" },
    ];

    return <CrudTemplate
        title="Gerenciar Fornecedores"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '95%' }}
        modalHeader="Fornecedor"
    />;
}
